"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.createTheme = void 0;

var _lodash = _interopRequireDefault(require("lodash.merge"));

var _createFontFamily = _interopRequireDefault(require("../theme/createFontFamily"));

var _styles = require("@material-ui/core/styles");

var _shadows = _interopRequireDefault(require("@material-ui/core/styles/shadows"));

var fontFamily = (0, _createFontFamily["default"])(['Lato', 'Avenir', 'Adobe Heiti Std', 'Segoe UI', 'Trebuchet MS', 'sans‑serif']);
var fontWeightLight = 300;
var fontWeightRegular = 500;
var fontWeightBold = 700;
var fontWeightBlack = 900;

var shadowRGBA = function shadowRGBA(a) {
  return "rgba(1, 42, 82, ".concat(a, ")");
};

var customShadows = [// i0
'none', // i1:
"0 2px 1px -1px ".concat(shadowRGBA(0.2), ", 0 0px 2px 0px ").concat(shadowRGBA(0.14), ", 0 1px 3px 0px ").concat(shadowRGBA(0.12)), // i2:
"0 3px 1px -2px ".concat(shadowRGBA(0.2), ", 0 2px 2px 0px ").concat(shadowRGBA(0.14), ", 0 1px 5px 0px ").concat(shadowRGBA(0.12)), // i3:
"0 3px 3px -2px ".concat(shadowRGBA(0.2), ", 0 3px 4px 0px ").concat(shadowRGBA(0.14), ", 0 1px 8px 0px ").concat(shadowRGBA(0.12)), // i4:
"0 2px 4px -1px ".concat(shadowRGBA(0.2), ", 0 4px 5px 0px ").concat(shadowRGBA(0.14), ", 0 1px 10px 0px ").concat(shadowRGBA(0.12)), // i5:
"0 3px 5px -1px ".concat(shadowRGBA(0.2), ", 0 5px 8px 0px ").concat(shadowRGBA(0.14), ", 0 1px 14px 0px ").concat(shadowRGBA(0.12)), // i6:
"0 3px 5px -1px ".concat(shadowRGBA(0.2), ", 0 6px 10px 0px ").concat(shadowRGBA(0.14), ", 0 1px 18px 0px ").concat(shadowRGBA(0.12)), // i7:
"0 4px 5px -2px ".concat(shadowRGBA(0.2), ", 0 7px 10px 1px ").concat(shadowRGBA(0.14), ", 0 2px 16px 1px ").concat(shadowRGBA(0.12)), // i8:
"0 5px 5px -3px ".concat(shadowRGBA(0.2), ", 0 8px 10px 1px ").concat(shadowRGBA(0.14), ", 0 3px 14px 2px ").concat(shadowRGBA(0.12)), // i9:
'none', // i10:
'none', // i11:
'none', // i12:
'none', // i13:
'none', // i14:
'none', // i15:
'none', // i16:
"0px 8px 10px -5px ".concat(shadowRGBA(0.2), ", 0px 16px 24px 2px ").concat(shadowRGBA(0.14), ", 0px 6px 30px 5px ").concat(shadowRGBA(0.12)), // i17:
"none", // i18:
"none", // i19:
"none", // i20:
"none", // i21:
"none", // i22:
"none", // i23:
"none", // i24:
"0px 11px 15px 7px ".concat(shadowRGBA(0.2), ", 0px 24px 38px 3px ").concat(shadowRGBA(0.14), ", 0px 9px 46px 8px ").concat(shadowRGBA(0.12))];
/**
 * https://material-ui.com/customization/themes/
 * https://material-ui.com/customization/default-theme/
 */

var createTheme = function createTheme() {
  var newShadows = (0, _lodash["default"])(_shadows["default"], customShadows);
  var baseOptions = {
    palette: {
      // TODO: Determine how we want to do theming on this component
      enterprise: {
        grey: {
          background: '#EDEEF5'
        },
        primary: '#546AE8',
        main: '#586BE0'
      },
      primary: {
        main: '#00ab61',
        light: '#33bb80',
        dark: '#007743',
        contrastText: '#FFFFFF'
      },
      secondary: {
        main: '#4175a9',
        contrastText: '#FFFFFF'
      },
      info: {
        main: '#4a75a9'
      },
      error: {
        main: '#d32f2f',
        dark: '#d32f2f',
        light: '#e57373',
        alt: '#952525',
        contrastText: '#FFFFFF'
      },
      warning: {
        main: '#f4c41d',
        text: '#212121'
      },
      // Todo: Deprecate once all apps have retired this and use warning instead
      warn: {
        main: '#ff9502',
        light: '#ffb74d',
        contrastText: '#FFFFFF'
      },
      success: {
        main: '#007743',
        light: '#f0f7f4',
        contrastText: '#165f3f'
      },
      ok: {
        main: '#007743',
        contrastText: '#FFFFFF'
      },
      background: {
        greyEnterprise: '#ECF3FF'
      }
    },
    typography: {
      useNextVariants: true,
      fontFamily: fontFamily,
      fontWeightLight: fontWeightLight,
      fontWeightRegular: fontWeightRegular,
      fontWeightMedium: fontWeightBold,
      fontSize: 16,
      h1: {
        fontSize: '97.82px',
        fontWeight: fontWeightBlack,
        letterSpacing: '-1.5px',
        lineHeight: '98px'
      },
      h2: {
        fontSize: '61.14px',
        fontWeight: fontWeightBlack,
        letterSpacing: '-0.5px',
        lineHeight: '62px'
      },
      h3: {
        fontSize: '48.91px',
        fontWeight: fontWeightBlack,
        lineHeight: '52px'
      },
      h4: {
        fontSize: '34.64px',
        fontWeight: fontWeightBlack,
        letterSpacing: '0.25px',
        lineHeight: '40px'
      },
      h5: {
        fontSize: '24.45px',
        fontWeight: fontWeightBlack,
        letterSpacing: '0.25px',
        lineHeight: '32px'
      },
      h6: {
        fontSize: '20.86px',
        fontWeight: fontWeightBlack,
        letterSpacing: '0.25px',
        lineHeight: '32px'
      },
      body1: {
        fontSize: '16.69px',
        fontWeight: fontWeightRegular,
        letterSpacing: '0.5px',
        lineHeight: '24px',
        color: '#424242'
      },
      body2: {
        fontSize: '14.6px',
        fontWeight: fontWeightRegular,
        letterSpacing: '0.25px',
        lineHeight: '22px',
        color: '#000000'
      },
      subtitle1: {
        fontSize: '16.69px',
        fontWeight: fontWeightRegular,
        letterSpacing: '0.17px',
        lineHeight: '24px',
        color: '#000000'
      },
      subtitle2: {
        fontSize: '14.6px',
        fontWeight: fontWeightRegular,
        letterSpacing: '0.1px',
        lineHeight: '24px',
        color: '#000000'
      },
      caption: {
        fontSize: '12.52px',
        letterSpacing: '0.4px',
        lineHeight: '18px'
      },
      overline: {
        fontSize: '12.23px',
        letterSpacing: '2px',
        lineHeight: '24px',
        fontWeight: fontWeightBlack
      },
      button: {
        fontSize: '14.27px',
        fontWeight: fontWeightBlack,
        letterSpacing: '1.25px',
        lineHeight: '24px'
      }
    },
    shape: {
      borderRadius: 6
    },
    shadows: newShadows,
    border: {
      solid: '1px solid #000000',
      light: '1px solid #FAFAFA'
    },
    props: {
      // Name of the component ⚛️
      MuiButtonBase: {
        // The properties to apply
        disableRipple: true // No more ripple, on the whole application 💣!

      }
    }
  };

  for (var _len = arguments.length, options = new Array(_len), _key = 0; _key < _len; _key++) {
    options[_key] = arguments[_key];
  }

  var mergedTheme = _lodash["default"].apply(void 0, [baseOptions].concat(options));

  return (0, _styles.unstable_createMuiStrictModeTheme)(mergedTheme);
};

exports.createTheme = createTheme;
var _default = createTheme;
exports["default"] = _default;